import { useCallback, useEffect, useState } from 'react';
import { AuthClient } from '../auth/AuthClient';
export function useAuth() {
    const [authState, setAuthState] = useState(AuthClient.getState());
    useEffect(() => {
        const unsubscribe = AuthClient.subscribe(setAuthState);
        return () => {
            unsubscribe();
        };
    }, []);
    return {
        state: authState,
        isAuthenticated: authState.status === 'authenticated',
        isLoading: authState.status === 'loading',
        isDenied: authState.status === 'denied',
        user: authState.status === 'authenticated' ? authState.user : null,
        error: authState.status === 'error' ? authState.error : null,
        login: useCallback(() => AuthClient.login(), []),
        logout: useCallback(() => AuthClient.logout(), []),
        getAccessToken: () => AuthClient.getAccessToken(),
        viewerMode: authState.status === 'authenticated' ? authState.viewerMode : false,
        setViewerMode: useCallback((enabled) => AuthClient.setViewerMode(enabled), [])
    };
}
export function usePermission(action) {
    const { user } = useAuth();
    return user ? user.actions.includes(action) : false;
}
export function useHasAnyPermission(actions) {
    const { user } = useAuth();
    return user ? actions.some((a) => user.actions.includes(a)) : false;
}
export function useHasAllPermissions(actions) {
    const { user } = useAuth();
    return user ? actions.every((a) => user.actions.includes(a)) : false;
}
export function useUserRole() {
    const { user } = useAuth();
    return user?.role || null;
}
